import PayFees from 'pages/Accountant/Fees/PayFees/Index';
import PaymentDetails from 'pages/Accountant/Fees/PaymentDetail/Index';
import UpdateInstallemt from 'pages/Accountant/Fees/UpdateInstallemt/Index';
import AddMonthlySalary from 'pages/Accountant/Salary/AddMonthlySalary/Index';
import CreateSalary from 'pages/Accountant/Salary/CreateSalary/Index';
import UpdateSalaryAmount from 'pages/Accountant/Salary/UpdateSalaryAmount/Index';
import ViewSalary from 'pages/Accountant/Salary/ViewSalary/Index';
import AccountantList from 'pages/Admin/Accountant/AccountantList/Index';
import AddAccountant from 'pages/Admin/Accountant/AddAccountant/Index';
import CreateAdmissions from 'pages/Admin/Admissions/CreateAdmissions/Index';
import AddNewBatch from 'pages/Admin/Course/AddNewBatch/Index';
import CourseList from 'pages/Admin/Course/CourseList/Index';
import CreateCourse from 'pages/Admin/Course/CreateCourse/Index';
import BatchStructureList from 'pages/Admin/BatchStructure/BatchStructureList/Index';
import CreateBatchStructure from 'pages/Admin/BatchStructure/CreateBatchStructure/Index';
import SwapBatch from 'pages/Admin/Course/SwapBatch/Index';
import SwapHistory from 'pages/Admin/Course/SwapHistory/Index';
import FeesDashboard from 'pages/Admin/Dashboards/FeesDashboard/Index';
import MainDashboard from 'pages/Admin/Dashboards/MainDashboard/Index';
import PlacementChart from 'pages/Admin/Dashboards/PlacementDashboard/PlacementChart/Index';
import HeadHRDashboard from 'pages/HeadHR/Dashboard/Index';
import HeadHRManageHRs from 'pages/HeadHR/ManageHRs/Index';
import HeadHRStudentOverview from 'pages/HeadHR/Students/StudentOverview/Index';
import HeadHRMarkPlacementReady from 'pages/HeadHR/Students/MarkPlacementReady/Index';
import AssignStudents from 'pages/HeadHR/AssignStudents/Index';
import JobFeedbacks from 'pages/Admin/Job/JobFeedbacks/Index';
import PauseStudentPlacement from 'pages/Admin/Job/PauseStudentPlacement/Index';
import AddHr from 'pages/Admin/Placement/AddHr/Index';
import PlacementTeamList from 'pages/Admin/Placement/ReadHr/Index';
import AllStudents from 'pages/Admin/Students/AllStudents/Index';
import MarkPlacementReady from 'pages/Admin/Students/MarkPlacementReady/Index';
import StudentFeeDetails from 'pages/Admin/Students/StudentFeeDetails/Index';
import StudentOverview from 'pages/Admin/Students/StudentOverview/Index';
import AssignTeacher from 'pages/Admin/Teachers/AssignTeacher/Index';
import AssignTeacherToMultipleLocation from 'pages/Admin/Teachers/AssignTeacherToMultipleLocation/Index';
import CreateTeacher from 'pages/Admin/Teachers/CreateTeacher/Index';
import TeacherList from 'pages/Admin/Teachers/ReadTeachers';
import BatchTimeDetails from 'pages/Admin/Timetable/BatchTimeDetails/Index';
import ViewMockMarksAdmin from 'pages/Admin/ViewMockMarks/Index';
import ExternalMockResultsAdmin from 'pages/Admin/ExternalMockResults/Index';
import ViewForgotPasswordRequests from 'pages/Admin/ForgotPassword/Index';
import Notification from 'pages/Common/Notification/Notification';
import SuperAdminNotification from 'pages/Common/Notification/SuperAdminNotification';
import SalaryDetails from 'pages/Common/SalaryDetails/Index';
import Login from 'pages/Login/Index';
// import AllJobPost from 'pages/PlacementAdmin/AllJobPost/Index';
// import AssignJobTostudent from 'pages/PlacementAdmin/AssignJob/AssignJobTostudent/Index';
// import CreateJob from 'pages/PlacementAdmin/CreateJob/Index';
import PlacementReadyStudent from 'pages/PlacementAdmin/PlacementReadyStudent/Index';
import OrgRegister from 'pages/Register/OrgRegister';
import DailyAssignment from 'pages/Student/Assignment/DailyAssignment/Index';
import EndAssignment from 'pages/Student/Assignment/EndAssignment/Index';
import GetPracticleAssignment from 'pages/Student/Assignment/GetPracticleAssignment/Index';
import MontlyAssignment from 'pages/Student/Assignment/MontlyAssignment/Index';
import ViewAssignment from 'pages/Student/Assignment/ViewAssignment/Index';
import WeeklyAssignment from 'pages/Student/Assignment/WeeklyAssignment/Index';
import StudentAttendanceReport from 'pages/Student/AttendanceReport/Index';
// import JobFeedbackManagement from 'pages/Student/Jobs/AddJobFeedback';
import AssignedJobs from 'pages/Student/Jobs/AssignedJobs';
import StudentPlacementPause from 'pages/Student/Jobs/PauseJob/Index';
import StudentOverAllData from 'pages/Student/Overview/Index';
import PendingTasks from 'pages/Student/PendingTasks/Index';
import StudentMockMarks from 'pages/Student/StudentMockMarks/StudentMockMarks';
import StudentExternalMockResults from 'pages/Student/ExternalMockResults/ExternalMockResults';
import StudentExternalPracticeResults from 'pages/Student/ExternalPracticeResults/ExternalPracticeResults';
import StudentTests from 'pages/Student/Test/Test/Index';
import ViewTest from 'pages/Student/Test/ViewTest/Index';
import TimeTable from 'pages/Student/TimeTable/Index';
import AllTrainingMaterials from 'pages/Student/AllTrainingMaterials/Index';
import TrainingMaterialUrls from 'pages/Student/TrainingMaterialUrls/Index';
import CreateAdmin from 'pages/SuperAdmin/Admin/CreateAdmin/Index';
import BlockedAdminList from 'pages/SuperAdmin/Admin/BlockedAdmin/AdminList';
import AdminList from 'pages/SuperAdmin/Admin/ReadAdmins/AdminList';
import AddBranch from 'pages/SuperAdmin/Branch/AddBranch';
import ReadBranches from 'pages/SuperAdmin/Branch/ReadBranches/Index';
import AddDepartment from 'pages/SuperAdmin/Department/AddDepartment';
import ReadDepartment from 'pages/SuperAdmin/Department/ReadDepartment/Index';
import AllResumes from 'pages/SuperAdmin/Resumes/Index';
import AddTrainingMaterial from 'pages/Teacher/AddTrainingMaterial/index';
import AssignTrainingMaterialUrl from 'pages/Teacher/AssignTrainingMaterialUrl/index';
import ViewTrainingMaterialUrls from 'pages/Teacher/ViewTrainingMaterialUrls/Index';
import AddVideoUrl from 'pages/Teacher/AddVideoUrl/index';
import AssignAssignment from 'pages/Teacher/Assignment/AssignAssignment/Index';
import CreateAssignment from 'pages/Teacher/Assignment/CreateAssignment/Index';
import CreateQAaasigment from 'pages/Teacher/Assignment/CreateQAaasigment/Index';
import CreatePracticleAssignment from 'pages/Teacher/Assignment/PracticleAssignment/CreatePracticleAssignment/Index';
import ReadPracticleAssignment from 'pages/Teacher/Assignment/PracticleAssignment/ReadPracticleAssignment/Index';
import ReadAssignment from 'pages/Teacher/Assignment/ReadAssignment/Index';
import ViewStudenAssignments from 'pages/Teacher/Assignment/ViewStudenAssignments/Index';
import MarkAttendance from 'pages/Teacher/Attendance/MarkAttendance/Index';
import AttendanceReport from 'pages/Teacher/Attendance/Report/Index';
import MockTest from 'pages/Teacher/MockTest/Index';
import ViewMockMarks from 'pages/Teacher/MockTest/ViewMockMarks/Index';
import ReadLectureLink from 'pages/Teacher/ReadLearningMaterial/ReadLectureLink/Index';
import ReadLink from 'pages/Teacher/ReadLearningMaterial/ReadLink/Index';
import AssignTest from 'pages/Teacher/Test/AssignTest/Index';
import CreateQAtest from 'pages/Teacher/Test/CreateQAtest/Index';
import CreateTest from 'pages/Teacher/Test/CreateTest/Index';
import ReadTest from 'pages/Teacher/Test/ReadTest/Index';
import Retest from 'pages/Teacher/Test/Retest/Index';
import TestToSingleStudent from 'pages/Teacher/Test/TestToSingleStudent/Index';
import ViewStudentAttendedTest from 'pages/Teacher/Test/ViewStudentAttendedTest/Index';
import CreatePracticalTest from 'pages/Teacher/Test/CreatePracticalTest/Index';
import ViewPracticalTests from 'pages/Teacher/Test/ViewPracticalTests/Index';
import StudentPracticalTest from 'pages/Student/Test/PracticalTest/Index';
import Announcements from 'pages/Announcement/Index';
import {
  MdAssignment,
  MdCampaign,
  MdDashboard,
  MdDescription,
  MdHome,
  MdLock,
  MdPerson,
  MdGroups,
  MdSmartToy,
} from 'react-icons/md';
import PdSessionList from 'pages/PdSession/List/Index';
import CreatePdSession from 'pages/PdSession/Create/Index';
import PdSessionDetail from 'pages/PdSession/Detail/Index';
import AiSessionList from 'pages/AiSession/List/Index';
import CreateAiSession from 'pages/AiSession/Create/Index';
import AiSessionDetail from 'pages/AiSession/Detail/Index';
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCenter.jsx';
import VerificationCentered from 'views/auth/verification/VerificationCenter.jsx';
import VerificationDefault from 'views/auth/verification/VerificationDefault.jsx';
// import AssignedPlacements from 'pages/PlacementAdmin/AssignedPlacements/Index';
import AllUnpausedStudent from 'pages/PlacementAdmin/AllUnpausedStudent/Index';
import AllPlacedStudents from 'pages/PlacementAdmin/AllPlacedStudents/Index';
import StudentAttachment from 'pages/PlacementAdmin/StudentAttachment/Index';
import ViewAttachments from 'pages/PlacementAdmin/StudentAttachment/ViewAttachments/Index';
// import StudentPlacementOverview from 'pages/PlacementAdmin/StudentPlacementOverview/Index';
import StudentGetPlacementOverview from 'pages/Student/Jobs/StudentGetPlacementOverview/Index';
import StudentResume from 'pages/Student/Resume/Index';
import MockTestLink from 'pages/PlacementAdmin/MockTestLink/Index';
import ViewwMockTestLink from 'pages/PlacementAdmin/MockTestLink/ViewMockMarks/Index';
import MockTests from 'pages/Student/MockTestLinks/Index';
import ProfileDetails from 'pages/Student/Profile/ProfileDetails/Index';
import PauseUnpauseHistory from 'pages/Admin/Job/PauseUnpauseHistory/Index';
import PdfAssignment from 'pages/Teacher/Assignment/PdfAssignment/CreatePdfAssignment/Index';
import ChangePassword from 'pages/Common/ChangePassword/Index';
import StudentPaymentDetails from 'pages/Student/Fees/PaymentDetail/Index';
import StudentMessaging from 'pages/Student/StudentMessaging/Index';
import AdminChatSystem from 'pages/Admin/Messaging/Index';
import StudentOffers from 'pages/Student/Jobs/StudentOffers/Index';
import FailedStudents from 'pages/Teacher/Test/FailedStudents/Index';
import CompanyManagement from 'pages/PlacementAdmin/CompanyManagement/Index';
import JobRoleManagement from 'pages/PlacementAdmin/JobRoleManagement/Index';
import AssignToCompany from 'pages/PlacementAdmin/AssignToCompany/Index';
import AssignmentOverview from 'pages/PlacementAdmin/AssignmentOverview/Index';
import OngoingInterviews from 'pages/PlacementAdmin/OngoingInterviews/Index';
import StudentTrainingMaterial from 'pages/Student/MyLearning/StudentTrainingMaterial';
const routes = [
  // --- Admin Dashboards ---
  {
    name: 'Dashboards',
    path: '/admin', // route  - will check it in app.js by using user role
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Main Dashboard',
        layout: '/admin', // layout match - will check it in sidebar by using layout
        path: '/', // route
        component: <MainDashboard />,
      },
    ],
  },
  {
    name: 'Announcements',
    path: '/admin',
    icon: <MdCampaign className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Announcements',
        layout: '/admin',
        path: '/announcements',
        exact: false,
        component: <Announcements />,
      },
    ],
  },

  {
    name: 'Profile',
    path: '/admin',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/admin',
        path: '/notification',
        exact: false,
        component: <Notification />,
      },
      {
        name: 'Chat',
        layout: '/admin',
        path: '/send/message',
        exact: false,
        component: <AdminChatSystem />,
      },
      {
        name: 'Salary Details',
        layout: '/admin',
        path: '/salary/details',
        exact: false,
        component: <SalaryDetails />,
      },
      {
        name: 'Reset Password',
        layout: '/admin',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
    ],
  },
  // --- Admin Main pages ---
  {
    name: 'Sections',
    path: '/admin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Accountant',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Create Accountant',
            layout: '/admin',
            path: '/create/accountants',
            exact: false,
            component: <AddAccountant />,
          },
          {
            name: 'View Accountant ',
            layout: '/admin',
            path: '/view/accountants',
            exact: false,
            component: <AccountantList />,
          },
        ],
      },

      {
        name: 'Course',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Create Course',
            layout: '/admin',
            path: '/create/course',
            exact: false,
            component: <CreateCourse />,
          },
          {
            name: 'View Course',
            layout: '/admin',
            path: '/view/courses',
            exact: false,
            component: <CourseList />,
          },
        ],
      },

      {
        name: 'Batch Structure',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Create Batch Structure',
            layout: '/admin',
            path: '/create/batch-structure',
            exact: false,
            component: <CreateBatchStructure />,
          },
          {
            name: 'View Batch Structure',
            layout: '/admin',
            path: '/view/batch-structures',
            exact: false,
            component: <BatchStructureList />,
          },
        ],
      },
      {
        name: 'Batch',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Batch Time Table',
            layout: '/admin',
            path: '/batch/timetable',
            exact: false,
            component: <BatchTimeDetails />,
          },
          {
            name: 'Create New Batch',
            layout: '/admin',
            path: '/create/new/batch',
            exact: false,
            component: <AddNewBatch />,
          },
          {
            name: 'Swap Student Batch',
            layout: '/admin',
            path: '/swap/batch',
            exact: false,
            component: <SwapBatch />,
          },
          {
            name: 'Swap Student History',
            layout: '/admin',
            path: '/swap/history',
            exact: false,
            component: <SwapHistory />,
          },
        ],
      },
      {
        name: 'Mock Test',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'View Mock Test Result',
            layout: '/admin',
            path: '/view/mock/result',
            exact: false,
            component: <ViewMockMarksAdmin />,
          },
        ],
      },
      {
        name: 'Placement',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Create HRs',
            layout: '/admin',
            path: '/create/hr/officer',
            exact: false,
            component: <AddHr />,
          },
          {
            name: 'View HRs',
            layout: '/admin',
            path: '/view/hr/officer',
            exact: false,
            component: <PlacementTeamList />,
          },
        ],
      },
      {
        name: 'Students',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Create Student',
            layout: '/admin',
            path: '/create/student',
            exact: false,
            component: <CreateAdmissions />,
          },
          {
            name: 'Job Feedbacks',
            layout: '/admin',
            path: '/job/feedbacks',
            exact: true,
            component: <JobFeedbacks />,
          },
          {
            name: 'Mark Placement Ready',
            layout: '/admin',
            path: '/mark/job/ready',
            exact: true,
            component: <MarkPlacementReady />,
          },
          {
            name: 'Pause Placement',
            layout: '/admin',
            path: '/pause/students/placement',
            exact: true,
            component: <PauseStudentPlacement />,
          },
          {
            name: 'Pause Unpause History',
            layout: '/admin',
            path: '/pause/unpause/history',
            exact: true,
            component: <PauseUnpauseHistory />,
          },
          {
            name: 'Student Overview',
            layout: '/admin',
            path: '/students/overall/performance',
            exact: true,
            component: <StudentOverview />,
          },
          {
            name: 'View Students',
            layout: '/admin',
            path: '/view/students/list',
            exact: false,
            component: <AllStudents />,
          },
          {
            name: 'Final Mock Result',
            layout: '/admin',
            path: '/view/external/mock/result',
            exact: false,
            component: <ExternalMockResultsAdmin />,
          },
        ],
      },
      {
        name: 'Teacher',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Assign Teacher to Created Location Batch',
            layout: '/admin',
            path: '/assign/teacher',
            exact: false,
            component: <AssignTeacher />,
          },
          {
            name: 'Assign Teacher to Multiple Locations Batch',
            layout: '/admin',
            path: '/assign/multiple/teacher',
            exact: false,
            component: <AssignTeacherToMultipleLocation />,
          },
          {
            name: 'Create Teacher',
            layout: '/admin',
            path: '/create/teachers',
            exact: false,
            component: <CreateTeacher />,
          },
          {
            name: 'View Teacher',
            layout: '/admin',
            path: '/view/teachers',
            exact: false,
            component: <TeacherList />,
          },
        ],
      },
    ],
  },
  {
    name: 'PD Sessions',
    path: '/admin',
    icon: <MdGroups className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'PD Session List',
        layout: '/admin',
        path: '/pd-session',
        exact: true,
        component: <PdSessionList />,
      },
      {
        name: 'Create PD Session',
        hideFromNav: true,
        layout: '/admin',
        path: '/pd-session/create',
        exact: true,
        component: <CreatePdSession />,
      },
      {
        name: 'PD Session Detail',
        hideFromNav: true,
        layout: '/admin',
        path: '/pd-session/detail',
        exact: true,
        component: <PdSessionDetail />,
      },
    ],
  },
  {
    name: 'AI Sessions',
    path: '/admin',
    icon: <MdSmartToy className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'AI Session List',
        layout: '/admin',
        path: '/ai-session',
        exact: true,
        component: <AiSessionList />,
      },
      {
        name: 'Create AI Session',
        hideFromNav: true,
        layout: '/admin',
        path: '/ai-session/create',
        exact: true,
        component: <CreateAiSession />,
      },
      {
        name: 'AI Session Detail',
        hideFromNav: true,
        layout: '/admin',
        path: '/ai-session/detail',
        exact: true,
        component: <AiSessionDetail />,
      },
    ],
  },

  // --- Main pages placement ---
  {
    name: 'Placement Sections',
    path: '/admin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Job Post',
        path: '/admin',
        collapse: true,
        items: [
          // {
          //   name: 'Add Job Post',
          //   layout: '/admin',
          //   path: '/hr/add/job',
          //   exact: false,
          //   component: <CreateJob />,
          // },
          // {
          //   name: 'View Job Post',
          //   layout: '/admin',
          //   path: '/hr/all/job-post',
          //   exact: false,
          //   component: <AllJobPost />,
          // },
          {
            name: 'Company Management',
            layout: '/admin',
            path: '/hr/company-management',
            exact: false,
            component: <CompanyManagement />,
          },
          {
            name: 'Job Roles',
            layout: '/admin',
            path: '/hr/job-roles',
            exact: false,
            component: <JobRoleManagement />,
          },
          {
            name: 'Assign Students to Company',
            layout: '/admin',
            path: '/hr/assign-to-company',
            exact: false,
            component: <AssignToCompany />,
          },
          {
            name: 'Assignment Overview',
            layout: '/admin',
            path: '/hr/assignment-overview',
            exact: false,
            component: <AssignmentOverview />,
          },
          {
            name: 'Ongoing Interviews',
            layout: '/admin',
            path: '/hr/ongoing-interviews',
            exact: false,
            component: <OngoingInterviews />,
          },
        ],
      },
      {
        name: 'Students ',
        path: '/admin',
        collapse: true,
        items: [
          // {
          //   name: 'Assign Jobs',
          //   layout: '/admin',
          //   path: '/hr/assign/jobs',
          //   exact: false,
          //   component: <AssignJobTostudent />,
          // },
          {
            // name: 'View Job Assigned',
            name: 'Student Placement Data',
            layout: '/admin',
            path: '/hr/view/admin/ready/students',
            exact: false,
            component: <PlacementReadyStudent />,
          },
          // {
          //   name: 'Company Placement Data',
          //   layout: '/admin',
          //   path: '/hr/view/assigned/placements',
          //   exaVct: false,
          //   component: <AssignedPlacements />,
          // },
          // {
          //   name: 'Placement Insights',
          //   layout: '/admin',
          //   path: '/view/students/placement/overview',
          //   exaVct: false,
          //   component: <StudentPlacementOverview />,
          // },

          {
            name: 'Students Attachment',
            layout: '/admin',
            path: '/add/students/attachment',
            exaVct: false,
            component: <StudentAttachment />,
          },
          {
            name: 'View Placed Students',
            layout: '/admin',
            path: '/view/all/placed/students',
            exaVct: false,
            component: <AllPlacedStudents />,
          },
          {
            name: 'View Student Attachments',
            layout: '/admin',
            path: '/view/all/students/attachment',
            exaVct: false,
            component: <ViewAttachments />,
          },
        ],
      },
    ],
  },
  // --- Main pages accountant ---
  {
    name: 'Accountant Sections',
    path: '/admin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Fee',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Fee & Installment Records',
            layout: '/admin',
            path: '/fee/details',
            exact: true,
            component: <StudentFeeDetails />,
          },
          {
            name: 'Fee Payment History',
            layout: '/admin',
            path: '/students/fees/info',
            exact: false,
            component: <PaymentDetails />,
          },
          {
            name: 'Pay Fees',
            layout: '/admin',
            path: '/pay-fees',
            exact: false,
            component: <PayFees />,
          },
          {
            name: 'Update Installment Details',
            layout: '/admin',
            path: '/update/installment/dates',
            exact: false,
            component: <UpdateInstallemt />,
          },
        ],
      },
      {
        name: 'Manage Salary',
        path: '/admin',
        collapse: true,
        items: [
          {
            name: 'Add Monthly Salary ',
            layout: '/admin',
            path: '/add/monthly/salary',
            exact: false,
            component: <AddMonthlySalary />,
          },
          {
            name: 'Create Salary',
            layout: '/admin',
            path: '/create/salary',
            exact: false,
            component: <CreateSalary />,
          },
          {
            name: 'Update Salary',
            layout: '/admin',
            path: '/update/employee/salary',
            exact: false,
            component: <UpdateSalaryAmount />,
          },
          {
            name: 'View Salary Details',
            layout: '/admin',
            path: '/view/all/employee/salary',
            exact: false,
            component: <ViewSalary />,
          },
        ],
      },
    ],
  },
  {
    name: 'Dashboards',
    path: '/student',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Placement Overview',
        layout: '/student',
        path: '/view/your/placement/overview',
        exact: false,
        component: <StudentGetPlacementOverview />,
      },
      {
        name: 'Student Dashboard',
        layout: '/student',
        path: '/',
        exact: false,
        component: <StudentOverAllData />,
      },
    ],
  },

  {
    name: 'Profile',
    path: '/student',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Profile Details',
        layout: '/student',
        path: '/profile',
        exact: false,
        component: <ProfileDetails />,
      },
      {
        name: 'Notifications',
        layout: '/student',
        path: '/notification',
        exact: false,
        component: <Notification />,
      },
      {
        name: 'Chat',
        layout: '/student',
        path: '/send/message',
        exact: false,
        component: <StudentMessaging />,
      },
      {
        name: 'Fee Payment History',
        layout: '/student',
        path: '/fees/info',
        exact: false,
        component: <StudentPaymentDetails />,
      },
    ],
  },
  // --- Main pages Students ---
  {
    name: 'Sections',
    path: '/student',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Assignment',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Daily Assignment',
            layout: '/student',
            path: '/daily/assignment',
            exact: false,
            component: <DailyAssignment />,
          },
          {
            name: 'End Assignment',
            layout: '/student',
            path: '/end/assignment',
            exact: false,
            component: <EndAssignment />,
          },
          {
            name: 'Montly Assignment',
            layout: '/student',
            path: '/montly/assignment',
            exact: false,
            component: <MontlyAssignment />,
          },
          {
            name: 'All Assignment',
            layout: '/student',
            path: '/submit/practicle/assignment',
            exact: false,
            component: <GetPracticleAssignment />,
          },
          {
            name: 'Weekly Assignment',
            layout: '/student',
            path: '/weekly/assignment',
            exact: false,
            component: <WeeklyAssignment />,
          },
        ],
      },
      {
        name: 'Attendance',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Attendance Report',
            layout: '/student',
            path: '/attendance-report',
            exact: false,
            component: <StudentAttendanceReport />,
          },
        ],
      },
      {
        name: 'Completed Task',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'View Assignment',
            layout: '/student',
            path: '/view/assignment',
            exact: false,
            component: <ViewAssignment />,
          },
          {
            name: 'View Test',
            layout: '/student',
            path: '/view/test',
            exact: false,
            component: <ViewTest />,
          },
        ],
      },
      {
        name: 'Mock Test',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'View Mock Result',
            layout: '/student',
            path: '/view/mock/result',
            exact: false,
            component: <StudentMockMarks />,
          },
          {
            name: 'View Mock Test Link',
            layout: '/student',
            path: '/view/mock/test/links',
            exact: false,
            component: <MockTests />,
          },
          {
            name: 'Final Mock Result',
            layout: '/student',
            path: '/view/external/mock/result',
            exact: false,
            component: <StudentExternalMockResults />,
          },
          {
            name: 'Practice Result',
            layout: '/student',
            path: '/view/external/practice/result',
            exact: false,
            component: <StudentExternalPracticeResults />,
          },
        ],
      },
      {
        name: 'Placement',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Assigned Job',
            layout: '/student',
            path: '/student/assigned/jobs',
            exact: false,
            component: <AssignedJobs />,
          },
          // {
          //   name: 'Interview Feedback',
          //   layout: '/student',
          //   path: '/assigned/job/feedback',
          //   exact: false,
          //   component: <JobFeedbackManagement />,
          // },
          {
            name: 'Offers',
            layout: '/student',
            path: '/offer/details',
            exact: false,
            component: <StudentOffers />,
          },
          {
            name: 'Pause Placement',
            layout: '/student',
            path: '/assigned/paused-placements',
            exact: false,
            component: <StudentPlacementPause />,
          },
          {
            name: 'Upload Resume',
            layout: '/student',
            path: '/student/resume',
            exact: false,
            component: <StudentResume />,
          },
        ],
      },
      {
        name: ' Task Details',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Pending Tasks',
            layout: '/student',
            path: '/student/view/pending/tasks',
            exact: false,
            component: <PendingTasks />,
          },
        ],
      },
      {
        name: 'Tests',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Practical Test',
            layout: '/student',
            path: '/practical/test/:id?',
            exact: false,
            component: <StudentPracticalTest />,
          },
          {
            name: 'Tests',
            layout: '/student',
            path: '/daily/test',
            exact: false,
            component: <StudentTests />,
          },
        ],
      },
      {
        name: 'Time Table',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Batch Time Table',
            layout: '/student',
            path: '/batch/timetable',
            exact: false,
            component: <TimeTable />,
          },
        ],
      },
      {
        name: 'Training Materials ',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Training Material URLs',
            layout: '/student',
            path: '/view/training-material-urls',
            exact: false,
            component: <TrainingMaterialUrls />,
          },
          {
            name: 'Shared Lecture Links',
            layout: '/student',
            path: '/view/shared/video/links',
            exact: false,
            component: <AllTrainingMaterials />,
          },
          {
            name: 'Shared Links',
            layout: '/student',
            path: '/view/shared/links',
            exact: false,
            component: <AllTrainingMaterials />,
          },
          {
            name: 'All Training Materials',
            layout: '/student',
            path: '/view/all/training/materials',
            exact: false,
            component: <AllTrainingMaterials />,
          },
        ],
      },
      {
        name: 'My Learning',
        path: '/student',
        collapse: true,
        items: [
          {
            name: 'Student Training Material',
            layout: '/student',
            path: '/view/shared/video/',
            exact: false,
            component: <StudentTrainingMaterial />,
          },
        ],
      },
    ],
  },

  {
    name: 'Dashboards',
    path: '/accountant',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Fees Dashboard',
        layout: '/accountant',
        path: '/',
        component: <FeesDashboard />,
      },
    ],
  },

  {
    name: 'Profile',
    path: '/accountant',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/accountant',
        path: '/notification',
        exact: false,
        component: <Notification />,
      },
      {
        name: 'Chat',
        layout: '/accountant',
        path: '/send/message',
        exact: false,
        component: <AdminChatSystem />,
      },
      {
        name: 'Salary Details',
        layout: '/accountant',
        path: '/salary/details',
        exact: false,
        component: <SalaryDetails />,
      },
      {
        name: 'Reset Password',
        layout: '/accountant',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
    ],
  },
  // --- Main pages accountant ---
  {
    name: 'Sections',
    path: '/accountant',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Fee',
        path: '/accountant',
        collapse: true,
        items: [
          {
            name: 'Fee Payment History',
            layout: '/accountant',
            path: '/students/fees/info',
            exact: false,
            component: <PaymentDetails />,
          },
          {
            name: 'Pay Fees',
            layout: '/accountant',
            path: '/pay-fees',
            exact: false,
            component: <PayFees />,
          },
          {
            name: 'Update Installment Details',
            layout: '/accountant',
            path: '/update/installment/dates',
            exact: false,
            component: <UpdateInstallemt />,
          },
        ],
      },
      {
        name: 'Manage Salary',
        path: '/accountant',
        collapse: true,
        items: [
          {
            name: 'Add Monthly Salary ',
            layout: '/accountant',
            path: '/add/monthly/salary',
            exact: false,
            component: <AddMonthlySalary />,
          },
          {
            name: 'View Salary Details',
            layout: '/accountant',
            path: '/view/all/employee/salary',
            exact: false,
            component: <ViewSalary />,
          },
        ],
      },
    ],
  },

  //DashBoard Teachers
  {
    name: 'Dashboards',
    path: '/teacher',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Teacher Dashboard',
        layout: '/teacher',
        path: '/',
        // component: <TeachersDefaultDashboard />,
        component: <MainDashboard />,
      },
    ],
  },
  {
    name: 'Announcements',
    path: '/teacher',
    icon: <MdCampaign className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Announcements',
        layout: '/teacher',
        path: '/announcements',
        exact: false,
        component: <Announcements />,
      },
    ],
  },
  {
    name: 'Profile',
    path: '/teacher',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/teacher',
        path: '/notification',
        component: <Notification />,
      },
      {
        name: 'Chat',
        layout: '/teacher',
        path: '/send/message',
        exact: false,
        component: <AdminChatSystem />,
      },
      {
        name: 'Reset Password',
        layout: '/teacher',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
      {
        name: 'Salary Details',
        layout: '/teacher',
        path: '/salary/details',
        exact: false,
        component: <SalaryDetails />,
      },
    ],
  },
  {
    name: 'PD Sessions',
    path: '/teacher',
    icon: <MdGroups className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'PD Session List',
        layout: '/teacher',
        path: '/pd-session',
        exact: true,
        component: <PdSessionList />,
      },
      {
        name: 'Create PD Session',
        hideFromNav: true,
        layout: '/teacher',
        path: '/pd-session/create',
        exact: true,
        component: <CreatePdSession />,
      },
      {
        name: 'PD Session Detail',
        hideFromNav: true,
        layout: '/teacher',
        path: '/pd-session/detail',
        exact: true,
        component: <PdSessionDetail />,
      },
    ],
  },
  {
    name: 'AI Sessions',
    path: '/teacher',
    icon: <MdSmartToy className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'AI Session List',
        layout: '/teacher',
        path: '/ai-session',
        exact: true,
        component: <AiSessionList />,
      },
      {
        name: 'Create AI Session',
        hideFromNav: true,
        layout: '/teacher',
        path: '/ai-session/create',
        exact: true,
        component: <CreateAiSession />,
      },
      {
        name: 'AI Session Detail',
        hideFromNav: true,
        layout: '/teacher',
        path: '/ai-session/detail',
        exact: true,
        component: <AiSessionDetail />,
      },
    ],
  },

  // --- Main pages Teacher ---
  {
    name: 'Sections',
    path: '/teacher',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Assignment',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Assign Assignment',
            layout: '/teacher',
            path: '/assign/assignment',
            exact: false,
            component: <AssignAssignment />,
          },
          {
            name: 'Create MCQ Assignment',
            layout: '/teacher',
            path: '/create-mcq-assignment',
            exact: false,
            component: <CreateAssignment />,
          },
          {
            name: 'Create QA Assignment',
            layout: '/teacher',
            path: '/create-qa-assignment',
            exact: false,
            component: <CreateQAaasigment />,
          },
          {
            name: 'Review Assignment',
            layout: '/teacher',
            path: '/review/assignment',
            exact: false,
            component: <ViewStudenAssignments />,
          },
          {
            name: 'View Assignment',
            layout: '/teacher',
            path: '/view/assignment',
            exact: false,
            component: <ReadAssignment />,
          },
        ],
      },
      {
        name: 'Attendance',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Mark Attendance',
            layout: '/teacher',
            path: '/mark-attendance',
            exact: false,
            component: <MarkAttendance />,
          },
          {
            name: 'View Attendance ',
            layout: '/teacher',
            path: '/view/attendance/report',
            exact: false,
            component: <AttendanceReport />,
          },
        ],
      },
      {
        name: 'Job',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Job Feedbacks',
            layout: '/teacher',
            path: '/job/feedbacks',
            exact: true,
            component: <JobFeedbacks />,
          },
        ],
      },
      {
        name: 'Mock Test',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Assign Mock Marks',
            layout: '/teacher',
            path: '/assign/mock/marks',
            exact: false,
            component: <MockTest />,
          },
          {
            name: 'View Mock Results',
            layout: '/teacher',
            path: '/view/mock/result',
            exact: false,
            component: <ViewMockMarks />,
          },
          {
            name: 'Mock Test Link',
            layout: '/teacher',
            path: '/create/mock/test/links',
            exaVct: false,
            component: <MockTestLink />,
          },
          {
            name: 'View Mock  Results',
            layout: '/teacher',
            path: '/view/mock/result',
            exact: false,
            component: <ViewMockMarks />,
          },
          {
            name: 'View Mock Test Link',
            layout: '/teacher',
            path: '/view/mock/test/links',
            exaVct: false,
            component: <ViewwMockTestLink />,
          },
        ],
      },
      {
        name: 'Practical Assignments',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Add Practical Assignment',
            layout: '/teacher',
            path: '/create/practical/assignment',
            exact: false,
            component: <CreatePracticleAssignment />,
          },
          {
            name: 'Upload Pdf Assignment',
            layout: '/teacher',
            path: '/create/pdf/assignment',
            exact: false,
            component: <PdfAssignment />,
          },
          {
            name: 'View Practical Assignments',
            layout: '/teacher',
            path: '/view/practical/assignments',
            exact: false,
            component: <ReadPracticleAssignment />,
          },
        ],
      },
      {
        name: 'Test',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Assign Test To Batches',
            layout: '/teacher',
            path: '/assign/test',
            exact: false,
            component: <AssignTest />,
          },
          {
            name: 'Assign Test To Student',
            layout: '/teacher',
            path: '/assign/test/to/student',
            exact: false,
            component: <TestToSingleStudent />,
          },
          {
            name: 'Create MCQ Test',
            layout: '/teacher',
            path: '/create-mcq-test',
            exact: false,
            component: <CreateTest />,
          },
          {
            name: 'Create QA Test',
            layout: '/teacher',
            path: '/create-qa-test',
            exact: false,
            component: <CreateQAtest />,
          },
          {
            name: 'Create Practical Test',
            layout: '/teacher',
            path: '/create/practical/test',
            exact: false,
            component: <CreatePracticalTest />,
          },
          {
            name: 'Review Test',
            layout: '/teacher',
            path: '/review/test',
            exact: false,
            component: <ViewStudentAttendedTest />,
          },
          {
            name: 'Retest',
            layout: '/teacher',
            path: '/retest',
            exact: false,
            component: <Retest />,
          },
          {
            name: 'View Test',
            layout: '/teacher',
            path: '/view/tests',
            exact: false,
            component: <ReadTest />,
          },
          {
            name: 'Failed Students',
            layout: '/teacher',
            path: '/view/failed-student',
            exact: false,
            component: <FailedStudents />,
          },
          {
            name: 'View Practical Tests',
            layout: '/teacher',
            path: '/view/practical/tests',
            exact: false,
            component: <ViewPracticalTests />,
          },
        ],
      },
      {
        name: 'Time Table',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'View Time Table',
            layout: '/teacher',
            path: '/batch/timetable',
            exact: false,
            component: <BatchTimeDetails />,
          },
        ],
      },
      {
        name: 'Training Material',
        path: '/teacher',
        collapse: true,
        items: [
          {
            name: 'Create Lecture Url',
            layout: '/teacher',
            path: '/create/lecture/url',
            exact: false,
            component: <AddVideoUrl />,
          },
          {
            name: 'Create Training Material',
            layout: '/teacher',
            path: '/create/training/material',
            exact: false,
            component: <AddTrainingMaterial />,
          },
          {
            name: 'Assign Training Material URL',
            layout: '/teacher',
            path: '/assign/training-material-url',
            exact: false,
            component: <AssignTrainingMaterialUrl />,
          },
          {
            name: 'View Training Material URLs',
            layout: '/teacher',
            path: '/view/training-material-urls',
            exact: false,
            component: <ViewTrainingMaterialUrls />,
          },
          {
            name: 'View/Edit Lecture Url',
            layout: '/teacher',
            path: '/view/edit/lecture/url',
            exact: false,
            component: <ReadLectureLink />,
          },
          {
            name: 'View/Edit Links Url',
            layout: '/teacher',
            path: '/view/edit/links/url',
            exact: false,
            component: <ReadLink />,
          },
        ],
      },
    ],
  },
  // --- Authentication ---
  {
    name: 'Authentication',
    path: '/auth',
    icon: <MdLock className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      // --- Sign In ---
      {
        name: 'Sign In',
        path: '/sign-in',
        collapse: true,
        items: [
          {
            name: 'Student',
            layout: '/auth',
            path: '/sign-in',
            component: <Login />,
          },
        ],
      },
      // --- Sign Up ---
      {
        name: 'Sign Up',
        path: '/sign-up',
        collapse: true,
        items: [
          {
            name: 'Org Register',
            layout: '/auth',
            path: '/sign-up/org',
            component: <OrgRegister />,
          },
        ],
      },
      // --- Verification ---
      {
        name: 'Verification',
        path: '/verification',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/verification/default',
            component: <VerificationDefault />,
          },
          {
            name: 'Centered',
            layout: '/auth',
            path: '/verification/centered',
            component: <VerificationCentered />,
          },
        ],
      },
      // --- Forgot Password ---
      {
        name: 'Forgot Password',
        path: '/forgot-password',
        collapse: true,
        items: [
          // {
          //   name: 'Default',
          //   layout: '/auth',
          //   path: '/forgot-password/default',
          //   component: <ForgotPasswordDefault />,
          // },
          {
            name: 'Forgot Password',
            layout: '/auth',
            path: '/forgot-password',
            component: <ForgotPasswordCentered />,
          },
        ],
      },
    ],
  },
  {
    name: 'Dashboards',
    path: '/superadmin',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Main Dashboard',
        layout: '/superadmin',
        path: '/',
        component: <MainDashboard />, //DashboardsDefault,
      },
    ],
  },
  {
    name: 'Announcements',
    path: '/superadmin',
    icon: <MdCampaign className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Announcements',
        layout: '/superadmin',
        path: '/announcements',
        exact: false,
        component: <Announcements />,
      },
    ],
  },
  {
    name: 'Resumes',
    path: '/superadmin',
    icon: <MdDescription className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'All Resumes',
        layout: '/superadmin',
        path: '/resumes',
        exact: false,
        component: <AllResumes />,
      },
    ],
  },
  {
    name: 'Profile',
    path: '/superadmin',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/superadmin',
        path: '/notification',
        exact: false,
        // component: <Notification />,
        component: <SuperAdminNotification />,
      },
      {
        name: 'Chat',
        layout: '/superadmin',
        path: '/send/message',
        exact: false,
        component: <AdminChatSystem />,
      },
      {
        name: 'Reset Password',
        layout: '/superadmin',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
    ],
  },

  {
    name: 'Super Admin Sections',
    path: '/superadmin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Admin',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Blocked Admin',
            layout: '/superadmin',
            path: '/view/blocked/admins',
            exact: false,
            component: <BlockedAdminList />,
          },
          {
            name: 'Create Admin',
            layout: '/superadmin',
            path: '/create/admin',
            exact: false,
            component: <CreateAdmin />,
          },
          {
            name: 'View Admin',
            layout: '/superadmin',
            path: '/view/admins',
            exact: false,
            component: <AdminList />,
          },
        ],
      },
      {
        name: 'Branch',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Branch',
            layout: '/superadmin',
            path: '/branch/create',
            exact: false,
            component: <AddBranch />,
          },
          {
            name: 'View Branches',
            layout: '/superadmin',
            path: '/view/branches',
            exact: false,
            component: <ReadBranches />,
          },
        ],
      },
      {
        name: 'Department',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Department',
            layout: '/superadmin',
            path: '/department/create',
            exact: false,
            component: <AddDepartment />,
          },
          {
            name: 'View Department',
            layout: '/superadmin',
            path: '/view/departments',
            exact: false,
            component: <ReadDepartment />,
          },
        ],
      },
    ],
  },
  // --- Admin Main pages ---
  {
    name: 'Admin Sections',
    path: '/superadmin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Accountant',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Accountant',
            layout: '/superadmin',
            path: '/create/accountants',
            exact: false,
            component: <AddAccountant />,
          },
          {
            name: 'View Accountant ',
            layout: '/superadmin',
            path: '/view/accountants',
            exact: false,
            component: <AccountantList />,
          },
        ],
      },

      {
        name: 'Course',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Course',
            layout: '/superadmin',
            path: '/create/course',
            exact: false,
            component: <CreateCourse />,
          },
          {
            name: 'View Course',
            layout: '/superadmin',
            path: '/view/courses',
            exact: false,
            component: <CourseList />,
          },
        ],
      },

      {
        name: 'Batch Structure',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Batch Structure',
            layout: '/superadmin',
            path: '/create/batch-structure',
            exact: false,
            component: <CreateBatchStructure />,
          },
          {
            name: 'View Batch Structure',
            layout: '/superadmin',
            path: '/view/batch-structures',
            exact: false,
            component: <BatchStructureList />,
          },
        ],
      },
      {
        name: 'Batch',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Batch Time Table',
            layout: '/superadmin',
            path: '/batch/timetable',
            exact: false,
            component: <BatchTimeDetails />,
          },
          {
            name: 'Create New Batch',
            layout: '/superadmin',
            path: '/create/new/batch',
            exact: false,
            component: <AddNewBatch />,
          },
          {
            name: 'Swap Student Batch',
            layout: '/superadmin',
            path: '/swap/batch',
            exact: false,
            component: <SwapBatch />,
          },
          {
            name: 'Swap Student History',
            layout: '/superadmin',
            path: '/swap/history',
            exact: false,
            component: <SwapHistory />,
          },
        ],
      },
      {
        name: 'Mock Test',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'View Mock Test Result',
            layout: '/superadmin',
            path: '/view/mock/result',
            exact: false,
            component: <ViewMockMarksAdmin />,
          },
        ],
      },
      {
        name: 'Forgot Password',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'View Forgot Password Requests',
            layout: '/superadmin',
            path: '/view/forgot-password',
            exact: false,
            component: <ViewForgotPasswordRequests />,
          },
        ],
      },
      {
        name: 'Placement',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create HRs',
            layout: '/superadmin',
            path: '/create/hr/officer',
            exact: false,
            component: <AddHr />,
          },
          {
            name: 'View HRs',
            layout: '/superadmin',
            path: '/view/hr/officer',
            exact: false,
            component: <PlacementTeamList />,
          },
        ],
      },
      {
        name: 'Students',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Create Student',
            layout: '/superadmin',
            path: '/create/student',
            exact: false,
            component: <CreateAdmissions />,
          },
          {
            name: 'Job Feedbacks',
            layout: '/superadmin',
            path: '/job/feedbacks',
            exact: true,
            component: <JobFeedbacks />,
          },
          {
            name: 'Mark Placement Ready',
            layout: '/superadmin',
            path: '/mark/job/ready',
            exact: true,
            component: <MarkPlacementReady />,
          },
          {
            name: 'Pause Placement',
            layout: '/superadmin',
            path: '/pause/students/placement',
            exact: true,
            component: <PauseStudentPlacement />,
          },
          {
            name: 'Pause Unpause History',
            layout: '/superadmin',
            path: '/pause/unpause/history',
            exact: true,
            component: <PauseUnpauseHistory />,
          },
          {
            name: 'Student Overview',
            layout: '/superadmin',
            path: '/students/overall/performance',
            exact: true,
            component: <StudentOverview />,
          },
          {
            name: 'View Students',
            layout: '/superadmin',
            path: '/view/students/list',
            exact: false,
            component: <AllStudents />,
          },
          {
            name: 'Final Mock Result',
            layout: '/superadmin',
            path: '/view/external/mock/result',
            exact: false,
            component: <ExternalMockResultsAdmin />,
          },
        ],
      },
      {
        name: 'Teacher',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Assign Teacher to Created Location Batch',
            layout: '/superadmin',
            path: '/assign/teacher',
            exact: false,
            component: <AssignTeacher />,
          },
          {
            name: 'Assign Teacher to Multiple Locations Batch',
            layout: '/superadmin',
            path: '/assign/multiple/teacher',
            exact: false,
            component: <AssignTeacherToMultipleLocation />,
          },
          {
            name: 'Create Teacher',
            layout: '/superadmin',
            path: '/create/teachers',
            exact: false,
            component: <CreateTeacher />,
          },
          {
            name: 'View Teacher',
            layout: '/superadmin',
            path: '/view/teachers',
            exact: false,
            component: <TeacherList />,
          },
        ],
      },
    ],
  },

  // --- Main pages accountant ---
  {
    name: 'Accountant Sections',
    path: '/superadmin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Fee',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Fee & Installment Records',
            layout: '/superadmin',
            path: '/fee/details',
            exact: true,
            component: <StudentFeeDetails />,
          },
          {
            name: 'Fee Payment History',
            layout: '/superadmin',
            path: '/students/fees/info',
            exact: false,
            component: <PaymentDetails />,
          },
          {
            name: 'Pay Fees',
            layout: '/superadmin',
            path: '/pay-fees',
            exact: false,
            component: <PayFees />,
          },
          {
            name: 'Update Installment Details',
            layout: '/superadmin',
            path: '/update/installment/dates',
            exact: false,
            component: <UpdateInstallemt />,
          },
        ],
      },
      {
        name: 'Manage Salary',
        path: '/superadmin',
        collapse: true,
        items: [
          {
            name: 'Add Monthly Salary ',
            layout: '/superadmin',
            path: '/add/monthly/salary',
            exact: false,
            component: <AddMonthlySalary />,
          },
          {
            name: 'Create Salary',
            layout: '/superadmin',
            path: '/create/salary',
            exact: false,
            component: <CreateSalary />,
          },
          {
            name: 'Update Salary',
            layout: '/superadmin',
            path: '/update/employee/salary',
            exact: false,
            component: <UpdateSalaryAmount />,
          },
          {
            name: 'View Salary Details',
            layout: '/superadmin',
            path: '/view/all/employee/salary',
            exact: false,
            component: <ViewSalary />,
          },
        ],
      },
    ],
  },

  {
    name: 'Placement Sections',
    path: '/superadmin',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Job Post',
        path: '/superadmin',
        collapse: true,
        items: [
          // {
          //   name: 'Add Job Post',
          //   layout: '/superadmin',
          //   path: '/hr/add/job',
          //   exact: false,
          //   component: <CreateJob />,
          // },
          // {
          //   name: 'View Job Post',
          //   layout: '/superadmin',
          //   path: '/hr/all/job-post',
          //   exact: false,
          //   component: <AllJobPost />,
          // },
          {
            name: 'Company Management',
            layout: '/superadmin',
            path: '/hr/company-management',
            exact: false,
            component: <CompanyManagement />,
          },
          {
            name: 'Template Management',
            layout: '/superadmin',
            path: '/hr/template-management',
            exact: false,
            component: <JobRoleManagement />,
          },
          {
            name: 'Assign Students to Company',
            layout: '/superadmin',
            path: '/hr/assign-to-company',
            exact: false,
            component: <AssignToCompany />,
          },
          {
            name: 'Assignment Overview',
            layout: '/superadmin',
            path: '/hr/assignment-overview',
            exact: false,
            component: <AssignmentOverview />,
          },
          {
            name: 'Ongoing Interviews',
            layout: '/superadmin',
            path: '/hr/ongoing-interviews',
            exact: false,
            component: <OngoingInterviews />,
          },
        ],
      },
      {
        name: 'Students ',
        path: '/superadmin',
        collapse: true,
        items: [
          // {
          //   name: 'Assign Jobs',
          //   layout: '/superadmin',
          //   path: '/hr/assign/jobs',
          //   exact: false,
          //   component: <AssignJobTostudent />,
          // },
          {
            // name: 'View Job Assigned',
            name: 'Student Placement Data',
            layout: '/superadmin',
            path: '/hr/view/superadmin/ready/students',
            exact: false,
            component: <PlacementReadyStudent />,
          },
          // {
          //   name: 'Company Placement Data',
          //   layout: '/superadmin',
          //   path: '/hr/view/assigned/placements',
          //   exact: false,
          //   component: <AssignedPlacements />,
          // },
          // {
          //   name: 'Placement Insights',
          //   layout: '/superadmin',
          //   path: '/view/students/placement/insights',
          //   exact: true,
          //   component: <StudentPlacementOverview />,
          // },

          {
            name: 'Students Attachment',
            layout: '/superadmin',
            path: '/add/students/attachment',
            exaVct: false,
            component: <StudentAttachment />,
          },
          {
            name: 'View Paused Students',
            layout: '/superadmin',
            path: '/view/all/paused/students',
            exaVct: false,
            component: <AllUnpausedStudent />,
          },
          {
            name: 'View Placed Students',
            layout: '/superadmin',
            path: '/view/all/placed/students',
            exaVct: false,
            component: <AllPlacedStudents />,
          },
          {
            name: 'View Student Attachments',
            layout: '/superadmin',
            path: '/view/all/students/attachment',
            exaVct: false,
            component: <ViewAttachments />,
          },
        ],
      },
    ],
  },
  {
    name: 'Dashboards',
    path: '/placement',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Placement Overview',
        layout: '/placement',
        path: '/',
        component: <PlacementChart />,
      },
    ],
  },
  {
    name: 'Announcements',
    path: '/placement',
    icon: <MdCampaign className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Announcements',
        layout: '/placement',
        path: '/announcements',
        exact: false,
        component: <Announcements />,
      },
    ],
  },
  {
    name: 'Profile',
    path: '/placement',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/placement',
        path: '/notification',
        exact: false,
        component: <Notification />,
      },
      // {
      //   name: 'Chat',
      //   layout: '/placement',
      //   path: '/send/message',
      //   exact: false,
      //   component: <AdminChatSystem />,
      // },
      // {
      //   name: 'Salary Details',
      //   layout: '/placement',
      //   path: '/salary/details',
      //   exact: false,
      //   component: <SalaryDetails />,
      // },
      {
        name: 'Reset Password',
        layout: '/placement',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
    ],
  },
  {
    name: 'PD Sessions',
    path: '/placement',
    icon: <MdGroups className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'PD Session List',
        layout: '/placement',
        path: '/pd-session',
        exact: true,
        component: <PdSessionList />,
      },
      {
        name: 'Create PD Session',
        hideFromNav: true,
        layout: '/placement',
        path: '/pd-session/create',
        exact: true,
        component: <CreatePdSession />,
      },
      {
        name: 'PD Session Detail',
        hideFromNav: true,
        layout: '/placement',
        path: '/pd-session/detail',
        exact: true,
        component: <PdSessionDetail />,
      },
    ],
  },
  {
    name: 'AI Sessions',
    path: '/placement',
    icon: <MdSmartToy className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'AI Session List',
        layout: '/placement',
        path: '/ai-session',
        exact: true,
        component: <AiSessionList />,
      },
      {
        name: 'Create AI Session',
        hideFromNav: true,
        layout: '/placement',
        path: '/ai-session/create',
        exact: true,
        component: <CreateAiSession />,
      },
      {
        name: 'AI Session Detail',
        hideFromNav: true,
        layout: '/placement',
        path: '/ai-session/detail',
        exact: true,
        component: <AiSessionDetail />,
      },
    ],
  },
  // --- Main pages accountant ---
  {
    name: 'Sections',
    path: '/placement',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Job Post',
        path: '/placement',
        collapse: true,
        items: [
          // {
          //   name: 'Add Job Post',
          //   layout: '/placement',
          //   path: '/hr/add/job',
          //   exact: false,
          //   component: <CreateJob />,
          // },
          // {
          //   name: 'View Job Post',
          //   layout: '/placement',
          //   path: '/hr/all/job-post',
          //   exact: false,
          //   component: <AllJobPost />,
          // },
          {
            name: 'Company Management',
            layout: '/placement',
            path: '/hr/company-management',
            exact: false,
            component: <CompanyManagement />,
          },
          {
            name: 'Template Management',
            layout: '/placement',
            path: '/hr/template-management',
            exact: false,
            component: <JobRoleManagement />,
          },
          {
            name: 'Assign Students to Company',
            layout: '/placement',
            path: '/hr/assign-to-company',
            exact: false,
            component: <AssignToCompany />,
          },
          {
            name: 'Assignment Overview',
            layout: '/placement',
            path: '/hr/assignment-overview',
            exact: false,
            component: <AssignmentOverview />,
          },
          {
            name: 'Ongoing Interviews',
            layout: '/placement',
            path: '/hr/ongoing-interviews',
            exact: false,
            component: <OngoingInterviews />,
          },
        ],
      },
      {
        name: 'Students ',
        path: '/placement',
        collapse: true,
        items: [
          // {
          //   name: 'Assign Jobs',
          //   layout: '/placement',
          //   path: '/hr/assign/jobs',
          //   exact: false,
          //   component: <AssignJobTostudent />,
          // },
          // {
          //   name: 'Company Placement Data',
          //   layout: '/placement',
          //   path: '/hr/view/assigned/placements',
          //   exaVct: false,
          //   component: <AssignedPlacements />,
          // },
          // {
          //   name: 'Placement Insights',
          //   layout: '/placement',
          //   path: '/view/students/placement/overview',
          //   exaVct: false,
          //   component: <StudentPlacementOverview />,
          // },
          {
            name: 'Student Placement Data',
            layout: '/placement',
            path: '/hr/view/placement/ready/students',
            exact: false,
            component: <PlacementReadyStudent />,
          },
          {
            name: 'Students Attachment',
            layout: '/placement',
            path: '/add/students/attachment',
            exaVct: false,
            component: <StudentAttachment />,
          },
          {
            name: 'View Placed Students',
            layout: '/placement',
            path: '/view/all/placed/students',
            exaVct: false,
            component: <AllPlacedStudents />,
          },
          {
            name: 'View Paused Students',
            layout: '/placement',
            path: '/view/all/paused/students',
            exact: false,
            component: <AllUnpausedStudent />,
          },
          {
            name: 'View Student Attachments',
            layout: '/placement',
            path: '/view/all/students/attachment',
            exaVct: false,
            component: <ViewAttachments />,
          },
          // {
          //   name: 'Mock Test Link',
          //   layout: '/placement',
          //   path: '/create/mock/test/links',
          //   exaVct: false,
          //   component: <MockTestLink />,
          // },
          // {
          //   name: 'View Mock Test Link',
          //   layout: '/placement',
          //   path: '/view/mock/test/links',
          //   exaVct: false,
          //   component: <ViewwMockTestLink />,
          // },
          //
        ],
      },
    ],
  },
  // --- Head HR Routes ---
  {
    name: 'Dashboards',
    path: '/headhr',
    icon: <MdHome className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Dashboard',
        layout: '/headhr',
        path: '/dashboard',
        component: <HeadHRDashboard />,
      },
    ],
  },
  {
    name: 'Announcements',
    path: '/headhr',
    icon: <MdCampaign className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Announcements',
        layout: '/headhr',
        path: '/announcements',
        exact: false,
        component: <Announcements />,
      },
    ],
  },
  {
    name: 'Assign Students',
    path: '/headhr',
    icon: <MdAssignment className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Assign Students',
        layout: '/headhr',
        path: '/assign-students',
        component: <AssignStudents />,
      },
    ],
  },
  {
    name: 'Manage HRs',
    path: '/headhr',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    requiresAllPermission: true,
    items: [
      {
        name: 'Manage HRs',
        layout: '/headhr',
        path: '/manage-hrs',
        component: <HeadHRManageHRs />,
      },
    ],
  },
  {
    name: 'Profile',
    path: '/headhr',
    icon: <MdPerson className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Notifications',
        layout: '/headhr',
        path: '/notification',
        exact: false,
        component: <Notification />,
      },
      {
        name: 'Chat',
        layout: '/headhr',
        path: '/send/message',
        exact: false,
        component: <AdminChatSystem />,
      },
      {
        name: 'Salary Details',
        layout: '/headhr',
        path: '/salary/details',
        exact: false,
        component: <SalaryDetails />,
      },
      {
        name: 'Reset Password',
        layout: '/headhr',
        path: '/reset/password',
        exact: false,
        component: <ChangePassword />,
      },
    ],
  },
  {
    name: 'PD Sessions',
    path: '/headhr',
    icon: <MdGroups className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'PD Session List',
        layout: '/headhr',
        path: '/pd-session',
        exact: true,
        component: <PdSessionList />,
      },
      {
        name: 'Create PD Session',
        hideFromNav: true,
        layout: '/headhr',
        path: '/pd-session/create',
        exact: true,
        component: <CreatePdSession />,
      },
      {
        name: 'PD Session Detail',
        hideFromNav: true,
        layout: '/headhr',
        path: '/pd-session/detail',
        exact: true,
        component: <PdSessionDetail />,
      },
    ],
  },
  {
    name: 'AI Sessions',
    path: '/headhr',
    icon: <MdSmartToy className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'AI Session List',
        layout: '/headhr',
        path: '/ai-session',
        exact: true,
        component: <AiSessionList />,
      },
      {
        name: 'Create AI Session',
        hideFromNav: true,
        layout: '/headhr',
        path: '/ai-session/create',
        exact: true,
        component: <CreateAiSession />,
      },
      {
        name: 'AI Session Detail',
        hideFromNav: true,
        layout: '/headhr',
        path: '/ai-session/detail',
        exact: true,
        component: <AiSessionDetail />,
      },
    ],
  },
  {
    name: 'Sections',
    path: '/headhr',
    icon: <MdDashboard className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: 'Job Post',
        path: '/headhr',
        collapse: true,
        items: [
          // {
          //   name: 'Add Job Post',
          //   layout: '/headhr',
          //   path: '/hr/add/job',
          //   exact: false,
          //   component: <CreateJob />,
          // },
          // {
          //   name: 'View Job Post',
          //   layout: '/headhr',
          //   path: '/hr/all/job-post',
          //   exact: false,
          //   component: <AllJobPost />,
          // },
          {
            name: 'Company Management',
            layout: '/headhr',
            path: '/hr/company-management',
            exact: false,
            component: <CompanyManagement />,
          },
          {
            name: 'Template Management',
            layout: '/headhr',
            path: '/hr/template-management',
            exact: false,
            component: <JobRoleManagement />,
          },
          {
            name: 'Assign Students to Company',
            layout: '/headhr',
            path: '/hr/assign-to-company',
            exact: false,
            component: <AssignToCompany />,
          },
          {
            name: 'Assignment Overview',
            layout: '/headhr',
            path: '/hr/assignment-overview',
            exact: false,
            component: <AssignmentOverview />,
          },
          {
            name: 'Ongoing Interviews',
            layout: '/headhr',
            path: '/hr/ongoing-interviews',
            exact: false,
            component: <OngoingInterviews />,
          },
        ],
      },
      {
        name: 'Students',
        path: '/headhr',
        collapse: true,
        items: [
          {
            name: 'Student Overview',
            layout: '/headhr',
            path: '/students/overall/performance',
            exact: true,
            component: <HeadHRStudentOverview />,
            requiresAllPermission: true,
          },
          {
            name: 'Mark Placement Ready',
            layout: '/headhr',
            path: '/mark/job/ready',
            exact: false,
            component: <HeadHRMarkPlacementReady />,
            requiresAllPermission: true,
          },
          // {
          //   name: 'Assign Jobs',
          //   layout: '/headhr',
          //   path: '/hr/assign/jobs',
          //   exact: false,
          //   component: <AssignJobTostudent />,
          // },
          // {
          //   name: 'Company Placement Data',
          //   layout: '/headhr',
          //   path: '/hr/view/assigned/placements',
          //   exact: false,
          //   component: <AssignedPlacements />,
          // },
          // {
          //   name: 'Placement Insights',
          //   layout: '/headhr',
          //   path: '/view/students/placement/overview',
          //   exact: false,
          //   component: <StudentPlacementOverview />,
          // },
          {
            name: 'Student Placement Data',
            layout: '/headhr',
            path: '/hr/view/placement/ready/students',
            exact: false,
            component: <PlacementReadyStudent />,
          },
          {
            name: 'Students Attachment',
            layout: '/headhr',
            path: '/add/students/attachment',
            exact: false,
            component: <StudentAttachment />,
          },
          {
            name: 'View Paused Students',
            layout: '/headhr',
            path: '/view/all/paused/students',
            exact: false,
            component: <AllUnpausedStudent />,
          },
          {
            name: 'View Placed Students',
            layout: '/headhr',
            path: '/view/all/placed/students',
            exact: false,
            component: <AllPlacedStudents />,
          },
          {
            name: 'View Student Attachments',
            layout: '/headhr',
            path: '/view/all/students/attachment',
            exact: false,
            component: <ViewAttachments />,
          },
        ],
      },
    ],
  },





];
export default routes;
